import * as yup from "yup";

export const CONTRACT_SELLER_EDIT_FORM_SCHEMA = yup.object().shape({
  sellerSalesPersonName: yup.string().required("Ime prodajne osobe je obavezan podatak"),
  sellerPhoneNumber: yup.string().required("Telefon prodavatelja je obavezan podatak"),
});
